// extracted by mini-css-extract-plugin
export default {"container":"iK-z","error":"jK-z","disabled":"kK-z","submit":"lK-z","option":"mK-z","success":"nK-z","failure":"oK-z"};